import React, { useEffect, useState } from "react";
import * as XLSX from 'xlsx';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Button from "@mui/material/Button";
import DragDropFile from "./DragDropFile";
import DataInput from "./DataInput";
import { Alert, AlertTitle } from "@mui/material";
import {
  Typography,
  InputLabel,
  CardContent,
  TextField,
  Grid,
  Box,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const QuizUpload = (props) => {
  const vertical = 'top';
  const horizontal = 'center';
  const [question, setQuestion] = useState({
    data: [],
    sheetname: [],
    questionFile: {},
    errorMessage: "",
  });

  const [state, setState] = React.useState({
    username: "",
    firstname: "",
    lastname: "",
    emailid: "",
    password: "",
    no_of_trainee: "",
    shortname: "",
    categoryid: "",
    errorMessage: ""
  });

  const [fileData, setFileData] = useState({});
  const [validationerror, setvalidationError] = React.useState(false);
  const [fileErrorMessage, setFileErrorMessage] = useState('');
  const [nameErrorMessage, setNameErrorMessage] = useState("");
  const [assessmentName, setAssessmentName] = useState("");

  const [open, setOpen] = React.useState(false);
  const [submitCompleted, setSubmitCompleted] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
    setSubmitCompleted(false);
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    setAssessmentName(value);
  };

  const handleClose = () => {
    setOpen(false);
    setQuestion({ data: "" });
    setFileErrorMessage("");
    setQuestion((prevState) => ({
      ...prevState,
      errorMessage: "",
      data: null
    }));
    setvalidationError(false);
    setAssessmentName("");
  };

  

  const handleSubmitClick = (e) => {
    e.preventDefault();
    if (assessmentName.trim() === '') {
      setNameErrorMessage('Please enter the Assessment Name');
      return;
    }

    if (question.data.length === 0) {
      setFileErrorMessage('Please select your excel file to upload questions');
      return;
    }

    fetch(`${process.env.REACT_APP_API_URL}/api/checkassessmentname/${assessmentName}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Network response was not ok.");
        }
      })
      .then((data) => {
        if (data.exists) {
          // setState({ errorMessage: "Assessment Name already exists. Please enter a different Name." });
          setNameErrorMessage("Assessment Name already exists. Please enter a different Name.");
          // setErrorMessage("Assessment Name already exists. Please enter a different Name.");
        } else {
          const formData = {
            data: question.data,
            assessmentName: assessmentName,
            status: "Active",
            organization_type: "Individual"
          };
          fetch(`${process.env.REACT_APP_API_URL}/api/quizdata/`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
            body: JSON.stringify(formData),
          })
            .then((response) => {
              if (response.ok) {
                setSubmitCompleted(true);
                DialogClose();
              }
              return response.json();
            })
            .then((data) => {
              if (data.code === 500) {
                setvalidationError(true);
                const id = "errorMessage";
                setState((prevState) => ({
                  ...prevState,
                  [id]: [data.message],
                }));
              } else {
                setSubmitCompleted(true);
                handleClose();
              }
            })
            .catch((error) => {
              console.error(error);
              setState({ errorMessage: "Something Went Wrong" });
            });
        }
      })
      .catch((error) => {
        console.error(error);
        setState({ errorMessage: "Something Went Wrong" });
      });
  };

  const DialogClose = () => {
    // setSubmitCompleted(false);
    window.location.href = '/app/assign';
  };

  useEffect(() => {
    setFileErrorMessage("");
  }, [question])

  const fileType = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];

  const handleFile = (file) => {
    if (file && fileType.includes(file.type)) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: 'binary' });

        const jsonArr = [];
        let numQuestions = 0;
        let isValidFile = true;
        wb.SheetNames.forEach(sheet => {
          const ws = wb.Sheets[sheet];
          const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
          console.log(data);
          console.log(data.length);
          const questionArr = [];

          if (data.length < 0 && data.length > 31) {
            isValidFile = false;
          }
          if (isValidFile) {
            for (let i = 0; i < data.length; i++) {
              const row = data[i];
              const data_type = row[0] ? row[0].toString().trim() : '';
              if (data_type === 'Multiple Choice') {
                if (row.length !== 7) {
                  isValidFile = false;
                  break;
                }
                console.log();
              } else if (data_type === 'Boolean' || data_type === 'Bolean') {
                if (row.length !== 5) {
                  isValidFile = false;
                  break;
                }
                console.log();
              } else {
                isValidFile = false;
                break;
              }
              console.log("checking is validfile or not --->", isValidFile);
            }
          }
          
          if (isValidFile) {
            console.log("Step-1");
            for (let i = 0; i < data.length; i++) {
              console.log("checking is validfile or not --->", isValidFile);
              const row = data[i];
              const data_type = row[0] ? row[0].toString().trim() : '';
              console.log(data_type);
              const [type, question, answer, option1, option2, option3, option4] = data[i];
              const [type1, question1, answer1, option5, option6,] = data[i];
              if (data_type === 'Multiple Choice' && question && answer && option1 && option2 && option3 && option4) {
                console.log(data[i]);
                if (typeof (question) === 'undefined') {
                  isValidFile = false;
                }
                if (typeof (answer) === 'undefined') {
                  isValidFile = false;
                }
                if (typeof (option1) === 'undefined') {
                  isValidFile = false;
                }
                if (typeof (option2) === 'undefined') {
                  isValidFile = false;
                }
                if (typeof (option3) === 'undefined') {
                  isValidFile = false;
                }
                if (typeof (option4) === 'undefined') {
                  isValidFile = false;
                }
                if (data[i] === '') {
                  isValidFile = false;
                }
                if (isValidFile === true) {
                  questionArr.push({
                    Type: type.toString(),
                    Question: question.toString(),
                    Answer: answer.toString(),
                    Option1: option1.toString(),
                    Option2: option2.toString(),
                    Option3: option3 ? option3.toString() : null,
                    Option4: option4 ? option4.toString() : null,
                  });
                  numQuestions++;
                }
              }
              else if (data_type === 'Boolean' || data_type === 'Bolean') {
                //console.log("question1", question1)
                //console.log("answer1", answer1)
                //console.log("option5", option5)
                //console.log("option6", option6)
                if (typeof (question1) === 'undefined') {
                  isValidFile = false;
                }
                if (typeof (answer1) === 'undefined') {
                  isValidFile = false;
                }
                if (typeof (option5) === 'undefined') {
                  isValidFile = false;
                }
                if (typeof (option6) === 'undefined') {
                  isValidFile = false;
                }
                if (data[i] === '') {
                  isValidFile = false;
                }
                if (isValidFile === true) {
                  questionArr.push({
                    Type: type.toString(),
                    Question: question.toString(),
                    Answer: answer.toString(),
                    Option1: option1.toString(),
                    Option2: option2.toString(),
                    Option3: option3 ? option3.toString() : null,
                    Option4: option4 ? option4.toString() : null,
                  });
                  numQuestions++;
                }
              } else {
                //console.log("hi");
                isValidFile = false;
              }
            }
          }
          jsonArr.push(...questionArr);
        });



        if (!isValidFile || numQuestions < 1) {
          setvalidationError(true);
          setQuestion((prevState) => ({
            ...prevState,
            errorMessage: "Please refer to the sample questionnaire and upload valid Assessment file",
            data: null
          }));
        } else if (numQuestions > 50) {
          setvalidationError(true);
          setQuestion((prevState) => ({
            ...prevState,
            errorMessage: "Maximum 50 questions can be uploaded",
            data: null
          }));
        } else {
          setQuestion({ data: jsonArr });
          setvalidationError(false);
        }
      };

      reader.readAsBinaryString(file);
    } else {
      setvalidationError(true);
      setQuestion((prevState) => ({
        ...prevState,
        errorMessage: "Please select only excel file types",
        data: null
      }));
    }
  };

  useEffect(() => {
    //console.log(question);
  }, [fileData])

  useEffect(() => {
    setFileErrorMessage("");
  }, [question])

  return (
    <>
      <Box sx={{ pt: 0 }}>
        <Box sx={{ width: '100%', maxWidth: { md: 1280 }, mx: 'auto', px: { xs: 1.5, sm: 2 }, display: 'flex', justifyContent: { xs: 'flex-start', sm: 'flex-start' } }}>
          <Tooltip title="Create Assessment" arrow>
            <span>
              <Button
                variant="contained"
                onClick={handleClickOpen}
                startIcon={<CloudUploadIcon />}
                sx={{ borderRadius: '50px', px: 2, py: 0.75, fontSize: '0.85rem' }}
                aria-label="Create Assessment"
              >
                Create Assessment
              </Button>
            </span>
          </Tooltip>
        </Box>
      </Box>
      <div className="App">
        <Dialog
          fullWidth
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          {validationerror ? (
            <Alert severity="error">
              <AlertTitle>Error </AlertTitle>
              {question.errorMessage}
            </Alert>
          ) : (
            ""
          )}
          <DialogTitle id="form-dialog-title">
            Upload Assessment Name and Assessment File in .csv, .xlsx, .xls format
          </DialogTitle>

          <DialogContent>
            <CardContent>
              <Grid container justify="center" spacing={3}>
                <Grid container spacing={3} item justify="flex-end" xs={12}>
                  <Grid item xs={7}>
                    <DragDropFile setFileData={setFileData} handleFile={handleFile}>
                      <div className="row">
                        <div className="col-xs-12">
                          <DataInput setFileData={setFileData} handleFile={handleFile} />
                          {fileErrorMessage && <Typography color="error" style={{ whiteSpace: 'nowrap', marginLeft: "105px", marginTop: "-10px", fontSize: "13px", lineHeight: "1.2" }}>{fileErrorMessage}</Typography>}
                        </div>
                      </div>
                      <br />
                    </DragDropFile>
                    <Typography variant="h6" style={{ whiteSpace: 'nowrap', marginTop: "-20px", marginBottom: "10px" }}>
                      Note: Assessment File can contain maximum of 50 questions.
                    </Typography>
                    <InputLabel>
                      Enter New Assessment Name
                      <small style={{ paddingLeft: "10px" }}>required</small>
                      <small style={{ color: "red" }}>*</small>
                    </InputLabel>
                    <TextField
                      fullWidth
                      name="assessmentName"
                      id="assessmentName"
                      onChange={(e) => {
                        setNameErrorMessage("");
                        handleChange(e);
                      }}
                      value={assessmentName}
                      required
                      size="small"
                      error={nameErrorMessage !== ""}
                      helperText={
                        <div style={{ display: "flex" }}>
                          {nameErrorMessage !== "" && (
                            <span style={{ marginLeft: "-12px" }}>
                              {nameErrorMessage}
                            </span>
                          )}
                        </div>
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </DialogContent>
          <DialogActions>
            <Tooltip title="Cancel" arrow>
              <span>
                <Button onClick={handleClose} color="primary" variant="contained" sx={{ borderRadius: '50px', px: 2, py: 0.75, fontSize: '0.85rem' }} aria-label="Cancel">
                  Cancel
                </Button>
              </span>
            </Tooltip>

            <Tooltip title="Create" arrow>
              <span>
                <Button
                  onClick={handleSubmitClick}
                  color="primary"
                  variant="contained"
                  disabled={
                    validationerror ||
                    !assessmentName || assessmentName.trim() === '' ||
                    !question.data || (Array.isArray(question.data) && question.data.length === 0)
                  }
                  sx={{ borderRadius: '50px', px: 2, py: 0.75, fontSize: '0.85rem' }}
                  aria-label="Create"
                >
                  Ok
                </Button>
              </span>
            </Tooltip>
          </DialogActions>
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            open={submitCompleted}
            // onClose={handleClose}
            key={vertical + horizontal}
            autoHideDuration={2000} // Show Snackbar for 3 seconds
            style={{ width: '750px', height: '100px' }}
          >
            <MuiAlert
              elevation={6}
              variant="filled"
              style={{ backgroundColor: "#38761d", fontSize: "20px" }}
                severity="info"
                autoHideDuration={2000} // Show Snackbar for 3 seconds
              // onClose={handleClose}
            >
              You have successfully created the assessment!
            </MuiAlert>
          </Snackbar>
        </Dialog>
      </div>
    </>
  );
};

export default QuizUpload;
